import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export function DeleteStudyButton({ study, onDeleted, iconOnly = false }) {
  const [busy, setBusy] = useState(false);
  const remove = async () => {
    setBusy(true);
    try {
      await api.delete(`/admin/studies/${study.id}`);
      toast.success("Değerlendirme ve tüm CV'ler silindi");
      onDeleted?.();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size={iconOnly ? "icon" : "sm"} data-testid={`delete-study-${study.id}`} aria-label="Değerlendirmeyi sil" disabled={busy} className="rounded-full text-plena-text2 hover:text-plena-coral">
          <Trash2 className={iconOnly ? "h-4 w-4" : "mr-1.5 h-3.5 w-3.5"} />{!iconOnly && "Sil"}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="delete-study-dialog" onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">“{study.title}” silinsin mi?</AlertDialogTitle>
          <AlertDialogDescription>Bu işlem geri alınamaz. İlan, {study.candidate_count ?? "tüm"} aday CV'si, değerlendirici atamaları ve verilen tüm puanlar kalıcı olarak silinecek.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-study-cancel" className="rounded-full">Vazgeç</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-study-confirm" onClick={remove} className="rounded-full bg-plena-coral text-white hover:bg-plena-coral/90">Kalıcı Olarak Sil</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
